import { Card, Button } from 'react-bootstrap';
import React from 'react';
import { getRefreshCadenceLabel } from './utils/cronUtils';
import { DGPTAlertConfig } from '../../types/dgptAlerts';
import { useAors } from '../../hooks/useAors';
import { useUpdateAlertConfig } from './hooks/useAlertConfigs';

type AlertConfigSummaryProps = {
  config: DGPTAlertConfig;
  s?: string;
};

export const AlertConfigSummary: React.FC<AlertConfigSummaryProps> = ({
  config,
  s,
}) => {
  const { data: allAors } = useAors();
  const updateConfig = useUpdateAlertConfig();
  const aorName =
    allAors?.find((aor) => aor.id === config.aorId)?.name || 'Not Set';

  const handleToggleActive = () => {
    updateConfig.mutate({
      id: config.id,
      active: !config.active,
    });
  };

  return (
    <Card bg="dark" className="mb-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <p className="mb-1">
              <strong>Name:</strong> {config.name}
            </p>
            <p className="mb-1">
              <strong>Event Type:</strong> {config.eventType || 'Not Set'}
            </p>
            <p className="mb-1">
              <strong>AOR:</strong> {aorName}
            </p>
            <p className="mb-1">
              <strong>Refresh Cadence:</strong>{' '}
              {getRefreshCadenceLabel(config.refreshCadence) || 'Not Set'}
            </p>
            {s ? (
              <p className="mb-1">
                <strong>Last Run:</strong> {s}
              </p>
            ) : null}
            <p className="mb-0">
              <strong>Status:</strong>{' '}
              <span
                className={`badge ${
                  config.active ? 'bg-success' : 'bg-secondary'
                }`}
              >
                {config.active ? 'Active' : 'Inactive'}
              </span>
              {config.archived && (
                <span className="badge bg-warning ms-2">Archived</span>
              )}
            </p>
          </div>
          <Button
            variant={config.active ? 'outline-danger' : 'outline-success'}
            onClick={handleToggleActive}
            disabled={updateConfig.isPending}
          >
            {config.active ? 'Deactivate' : 'Activate'}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};
